// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../index';

import { MeFragmentDoc } from '../../fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../../fragments/costumerConsultant.fragment.generated';
export const LoginResponseSuccessFragmentDoc = `
    fragment loginResponseSuccess on LoginResponseSuccess {
  __typename
  jwt
  user {
    ...me
  }
}
    `;